module.exports = __webpack_public_path__ + "static/media/paymentPOPUP.87ee9aa5.png";